export const AUTH_SLICE_NAME = 'AUTH';
export const USER_SLICE_NAME = 'USER';
export const PAYMENT_SLICE_NAME = 'PAYMENT';
export const CALLBACK_SLICE_NAME = 'CALLBACK';
export const BALANCE_SLICE_NAME = 'BALANCE';
export const NETWORKS_SLICE_NAME = 'NETWORKS';
